import {Component, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IOffices} from 'src/app/interfaces/settings.iterfaces';
import {DialogService} from 'src/app/services/dialog.service';
import {SettingsService} from 'src/app/services/settings.service';
import {UITableHeader} from 'src/app/shared/ui-kits/table/table.models';
import {OfficeModalComponent} from './office-modal/office-modal.component';
import {filter} from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-offices',
  templateUrl: './offices.component.html',
  styleUrls: ['./offices.component.scss'],
})
export class OfficesComponent implements OnInit {
  public tableOfficeData: IOffices[] = [];
  public tableOfficeHeaders: UITableHeader[] = [
    {key: 'officeName', index: 0},
    {key: 'countryId', index: 1, notVisible: true},
    {key: 'countryName', index: 2},
    {key: 'id', index: 3, notVisible: true},
    {key: 'address', index: 4},
  ];
  constructor(
    private settingsService: SettingsService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.getAllOffices();
  }

  addNewOffice() {
    this.dialogService
      .open(OfficeModalComponent, {
        settings: {
          height: '350px',
        },
      })
      .afterClosed()
      .pipe(
        untilDestroyed(this),
        filter(res => !!res)
      )
      .subscribe(result => {
        this.settingsService
          .addOffice(result)
          .pipe(untilDestroyed(this))
          .subscribe(() => {
            this.getAllOffices();
          });
      });
  }

  getAllOffices() {
    this.settingsService
      .getOffices()
      .pipe(untilDestroyed(this))
      .subscribe((response: IOffices[]) => (this.tableOfficeData = response));
  }
}
